 import React,{useEffect,useState} from "react";
 import {useSearchParams} from "react-router-dom";
 import logo from '../../../img/qbs_learning.png';
 import { getSingleCondidate } from "../../../Redux/Actions/newJoinerAction";
 import { useDispatch,useSelector } from "react-redux";
 import {getNewJoinerDetails,httpCreateCondidatePersonalDetails,sendFormAuthCode} from '../../HR/onboarding/api/Calls';
 import moment from "moment";
 import AddFamilyDetail from "./AddFamilyDetail";

import EmailVerification from "./EmailVerification";
import { useNavigate } from "react-router-dom";


function NewJoiningFrom(){
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const [tab,setTab] = useState(1);
    const { onecondidate } = useSelector((state) => state.NewJoinerReducer);
    const initialstate = {
        salutation:'',
        firstname:'',
        middlename:'',
        lastname:'',
        fatherhusbandname:'',
        gender:'',
        email:'',
        alternateemail:'',
        phonenumber:'',
        dateofbirth:'',
        age:'',
        hobbies:'',
        marital_status:'',
        weddinganniversary:'',
        dateofjoining:'',
        bloodgroup:'',
        Weight:'',
        Height:'',
        personrelation:'',
        nationality:'',
        aadhaarcardnumber:'',
        pancardnumber:"",
        uanno:"",
        Passportno:"",
        currentAddress:"",
        PermanentAddress:"",
        bankSalaryType:"",
        accountno:"",
        ifsc_code:"",
    }
    const [CandidateData,setCandidateData] = useState();
    const [formValues,setFormValues] = useState(initialstate);
    const [AadharcardFiles,setFormAadharcardFilesValues] = useState('');
    const [Filepancard,setFormFilepancardValues] = useState('');
    const [PassportSizePhoto,setFormPassportSizePhotoValues] = useState('');
    const [AddressProof,setFormAddressProofValues] = useState('');
    const [CancelCheck,setFormCancelCheckValues] = useState('');
    const [Vaccination,setFormVaccinationValues] = useState('');

    const [emailCheck, setEmailCheck] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [error,setError] = useState(false)
    const [color,setColor] = useState('');
    const [age,setAge] = useState('');
   // const [Emergencycontactperson,setEmergencycontactperson] = useState('');
   const NumericValueState = {
    emergencycontactperson:'',
    emergencyphonenumber:''
   }
    const [Numeric,setNumeric] = useState(NumericValueState);


    
    const values = searchParams.get('verify')
   const [isCheckTwoFectorAuth,setIsCheckTwoFectorAuthtication] = useState(0);
   console.log(isCheckTwoFectorAuth)
    useEffect(() => {
       
        const base64EncodedString = values;
        const decodedString =window.atob(base64EncodedString);
        //console.log(decodedString);
        setEmailCheck(decodedString)
        dispatch(getSingleCondidate(emailCheck));
        if(isCheckTwoFectorAuth === 0 && onecondidate?.status === 0){
          getEmailVerifyCode(decodedString);
        }else{
          if(isCheckTwoFectorAuth == 1){
            getCondidateDetail()
          }
        }
        
       
    }, [isCheckTwoFectorAuth,tab]);

    const handleChange =  (e) => {
      const { name, value } = e.target;
      setFormValues({ ...formValues, [name]: value });

      if(formValues.dateofbirth){
        var today = new Date();
       // console.log(today)
        var birthDate = new Date(`${moment(formValues.dateofbirth).format('YYYY-MM-DD')}`);  // create a date object directly from `dob1` argument
       // console.log(birthDate)
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age_now--;
        }
        setAge(age_now)
       // console.log(age_now);
  
      }else{
        setAge('');
      }
      
    };
    const handleNumericChange =(e) =>{
      const { name, value } = e.target;
      const re = /^[0-9]*[.,]?[0-9]*$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        setNumeric({...Numeric,[name]:value})
      }
   }
    const handleAadharcardFilesChange =  (e) => {
      setFormAadharcardFilesValues(e.target.files[0]);
    };
    const handleFilepancardChange =  (e) => {
      setFormFilepancardValues(e.target.files[0]);
    };
    const handlePassportSizePhotoChange =  (e) => {
      setFormPassportSizePhotoValues(e.target.files[0]);
    };
    const handleAddressProofChange =  (e) => {
      setFormAddressProofValues(e.target.files[0]);
     
    };
    const handleCancelCheckChange =  (e) => {
      setFormCancelCheckValues(e.target.files[0]);
    };
    const handleVaccinationChange =  (e) => {
      setFormVaccinationValues(e.target.files[0]);
    };
    const getCondidateDetail = () =>{
     
        getNewJoinerDetails(emailCheck).then((data) =>{
           // console.log(data);
            setCandidateData(data);
            setFormValues(data)
        })
    }
    const getEmailVerifyCode = (emailID) =>{
      sendFormAuthCode(emailID).then((data) =>{
        // console.log(data);
        if(data.status){
          setIsCheckTwoFectorAuthtication(1)
        }else{
          setIsCheckTwoFectorAuthtication(0)
        }
        
     })
    }
    
    const validateValues = (e) => {
      console.log(error)
      console.log(formValues)
      if(formValues.salutation ===''){
        setError({submition:false});
        setColor({salutation:'red'})
        e.target.querySelector('#salutation').focus()
      
      }else if(formValues.fatherhusbandname ===''){
        setError({submition:false});
        setColor({fatherhusbandname:'red'})
        e.target.querySelector('#fatherhusbandname').focus()
      }else if(formValues.gender ===''){
        setError({submition:false});
        setColor({gender:'red'})
        e.target.querySelector('#gender').focus()
      }else if(formValues.email  === '' && CandidateData.personal_email ===''){
        setError({submition:false});
        setColor({email:'red'})
        e.target.querySelector('#email').focus()
      }else if(formValues.phonenumber ==='' && CandidateData.contact_no ===''){
        setError({submition:false});
        setColor({phonenumber:'red'})
        e.target.querySelector('#phonenumber').focus()
      }else if(formValues.dateofbirth ===''){
        setError({submition:false});
        setColor({dateofbirth:'red'})
        e.target.querySelector('#dateofbirth').focus()
      }else if(formValues.marital_status ===''){
        setError({submition:false});
        setColor({marital_status:'red'})
        e.target.querySelector('#marital_status').focus()
      }else if(formValues.bloodgroup ===''){
        setError({submition:false});
        setColor({bloodgroup:'red'})
        e.target.querySelector('#bloodgroup').focus()
      }else if(Numeric.emergencycontactperson ===''){
        setError({submition:false});
        setColor({emergencycontactperson:'red'})
        e.target.querySelector('#emergencycontactperson').focus()
      }else if(formValues.personrelation ===''){
        setError({submition:false});
        setColor({personrelation:'red'})
        e.target.querySelector('#personrelation').focus()
      }else if(Numeric.emergencyphonenumber ===''){
        setError({submition:false});
        setColor({emergencyphonenumber:'red'})
        e.target.querySelector('#emergencyphonenumber').focus()
      }else if(formValues.nationality ===''){
        setError({submition:false});
        setColor({nationality:'red'})
        e.target.querySelector('#nationality').focus()
      }else if(formValues.aadhaarcardnumber ===''){
        setError({submition:false});
        setColor({aadhaarcardnumber:'red'})
        e.target.querySelector('#aadhaarcardnumber').focus()
      }else if(AadharcardFiles ===''){
        setError({submition:false});
        setColor({aadharcardfile:'red'})
        e.target.querySelector('#aadharcardfile').focus()
      }else if(formValues.pancardnumber ===''){
        setError({submition:false});
        setColor({pancardnumber:'red'})
        e.target.querySelector('#pancardnumber').focus()
      }else if(Filepancard ===''){
        setError({submition:false});
        setColor({filepancard:'red'})
        e.target.querySelector('#filepancard').focus()
      }else if(PassportSizePhoto ===''){
        setError({submition:false});
        setColor({passportSizePhoto:'red'})
        e.target.querySelector('#passportSizePhoto').focus()
      }else if(AddressProof ===''){
        setError({submition:false});
        setColor({AddressProof:'red'})
        e.target.querySelector('#AddressProof').focus()
      }else if(formValues.currentAddress ===''){
        setError({submition:false});
        setColor({currentAddress:'red'})
        e.target.querySelector('#currentAddress').focus()
      }else if(formValues.PermanentAddress ===''){
        setError({submition:false});
        setColor({PermanentAddress:'red'})
        e.target.querySelector('#PermanentAddress').focus()
      }else if(formValues.bankSalaryType ===''){
        setError({submition:false});
        setColor({bankSalaryType:'red'})
        e.target.querySelector('#bankSalaryType').focus()
      }else if(formValues.accountno ===''){
        setError({submition:false});
        setColor({accountno:'red'})
        e.target.querySelector('#accountno').focus()
      }else if(formValues.ifsc_code ===''){
        setError({submition:false});
        setColor({ifsc_code:'red'})
        e.target.querySelector('#ifsc_code').focus()
      }else if(CancelCheck ===''){
        setError({submition:false});
        setColor({cancelCheck:'red'})
        e.target.querySelector('#cancelCheck').focus()
      }else{
        setError({submition:true});
        return error;
      }
      return error;
    };
    const handleSavePersonalProfile = (e) =>{
        e.preventDefault();
        validateValues(e);
       //setError({submition:true});
        if(error.submition == true){

         //const NewData = Object.values(formValues.AddressProof)
          const formdata = new FormData();
          formdata.append('salutation', formValues.salutation);
          formdata.append('firstname', CandidateData.first_name?CandidateData.first_name:formValues.firstname);
          formdata.append('middlename', formValues.middlename);
          formdata.append('lastname', formValues.lastname);
          formdata.append('fatherhusbandname', formValues.fatherhusbandname);
          formdata.append('gender', formValues.gender);
          formdata.append('email', CandidateData.personal_email?CandidateData.personal_email:formValues.email);
          formdata.append('alternateemail', formValues.alternateemail);
          formdata.append('phonenumber', CandidateData.contact_no?CandidateData.contact_no:formValues.phonenumber);
          formdata.append('dateofbirth', formValues.dateofbirth);
          formdata.append('age',age);
          formdata.append('hobbies',formValues.hobbies);
          formdata.append('marital_status',formdata.marital_status);
          formdata.append('weddinganniversary', formValues.weddinganniversary);
          formdata.append('dateofjoining',CandidateData.dateofjoining?CandidateData.dateofjoining:formValues.dateofjoining)
         
          formdata.append('bloodgroup',formdata.bloodgroup);
          formdata.append('Weight',formdata.Weight);
          formdata.append('Height',formValues.Height);

          formdata.append('emergencycontactperson',Numeric.emergencycontactperson);
          formdata.append('personrelation',formValues.personrelation);
          formdata.append('emergencyphonenumber',Numeric.emergencyphonenumber);
          formdata.append('nationality',formValues.nationality);
          formdata.append('aadhaarcardnumber',formdata.aadhaarcardnumber);
          formdata.append('pancardnumber',formValues.pancardnumber);
          formdata.append('uanno', formValues.uanno);
          formdata.append('Passportno',formValues.Passportno);
          formdata.append('currentAddress',formValues.currentAddress);
          formdata.append('PermanentAddress',formValues.PermanentAddress);
          formdata.append('bankSalaryType',formValues.bankSalaryType);
          formdata.append('accountno',formValues.accountno);
          formdata.append('ifsc_code',formValues.ifsc_code);

          formdata.append('AddressProof', AddressProof);
          formdata.append('PassportSizePhoto', PassportSizePhoto);
          formdata.append('Filepancard', Filepancard);
          formdata.append('AadharcardFiles', AadharcardFiles);
          formdata.append('cancelCheck', CancelCheck);
          formdata.append('Vaccination',Vaccination);
          // console.log(formdata)
          // console.log('formsubmited')
    
          httpCreateCondidatePersonalDetails(formdata,CandidateData?.condidateID).then((res) => {
            if (res.status) {
              setTab(2);
              setFormValues('')
              setNumeric('')
              return alert(res.msg);
            } else {
              return alert(res.msg);
            }
          });
        }
        
       // return alert("All fields are required");
    }
    const saveFamilyDetails = () =>{
      //e.preventDefault();
      setTab(3);
  }
//     console.log(tab)
//     // console.log(error)
// console.log('formValues')
// console.log(formValues)
// console.log('onecondidate')
//  console.log(onecondidate)
    return (
        <>
        {onecondidate?.status === 1 ? navigate('/joining-success')  :
        
        <>
         {isCheckTwoFectorAuth === 0 ? 
        <>
        <EmailVerification emailCheck={emailCheck} setIsCheckTwoFectorAuthtication={setIsCheckTwoFectorAuthtication}/>
        </>:
        <>
        <main className="user_maincontainer">
          <div className="container-fluid">
            <div className="company_logo">
              <img src={logo} alt="logo" className="company_logo" />
            </div>
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10">
                <div className="profile_wrapper mb30">
                  <div className="nav" id="profile-tab" role="tablist" aria-orientation="vertical">
                    <a className={`nav-link ${tab ===1 ? 'active':''}`} onClick={()=> setTab(1)} id="employmentprofile-tab" data-bs-toggle="tab" href="#employmentprofile" data-bs-target="#employmentprofile">
                      Personal Profile
                    </a>
                    <span className="middleline" />
                    <a className={`nav-link ${tab ===2 ? 'active':''}`} onClick={()=> setTab(2)} id="familydetail-tab" data-bs-toggle="tab" href="#familydetail" data-bs-target="#familydetail">
                      Family Detail
                    </a>
                    <span className="middleline" />
                    <a className={`nav-link ${tab ===3 ? 'active':''}`} onClick={()=> setTab(3)} id="qualification-tab" data-bs-toggle="tab" href="#qualificationdetail" data-bs-target="#qualificationdetail">
                      Qualification Detail
                    </a>
                    <span className="middleline" />
                    <a className={`nav-link ${tab ===4 ? 'active':''}`} onClick={()=> setTab(4)} id="previousemployment-tab" data-bs-toggle="tab" href="#previousemploymentdetail" data-bs-target="#previousemploymentdetail">
                      Previous Employment Detail
                    </a>
                  </div>
                  <div className="tab-content" id="profile-tabContent">
                    
                    <div className={`tab-pane fade ${tab === 1? 'show active':''}`} id="employmentprofile" role="tabpanel" aria-labelledby="employmentprofile-tab">
                    <form onSubmit={handleSavePersonalProfile}>
                        <div className="tab_content">
                        <div className="dash_white_box_ttl">PERSONAL PROFILE</div>
                        <div className="row mb25">
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Salutation <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.salutation === 'red' ? 'redvalidation_input':''} ${color.salutation === 'green' ? 'greenvalidation_input':''}`}>
                                <select className="form-select" name="salutation" value={formValues.salutation} onChange={handleChange} id="salutation">
                                  <option value="">Select Salutation</option>
                                  <option value='1'>Mr.</option>
                                  <option value='2'>Mis.</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">First Name <span style={{fontSize: '11px', color: '#848484', fontWeight: 'normal'}}>(As Per Aadhaar Card)<span><sup className="error_mgs">*</sup></span></span></div>
                              <div className="form-input">
                                <input type="text" name="" value={CandidateData?.first_name} id="firstname" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Middle Name <span style={{fontSize: '11px', color: '#848484', fontWeight: 'normal'}}>(As Per Aadhaar Card)<span /></span></div>
                              <div className="form-input">
                                <input type="text" name="middlename" value={formValues.middlename} onChange={handleChange} id="middlename" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Last Name <span style={{fontSize: '11px', color: '#848484', fontWeight: 'normal'}}>(As Per Aadhaar Card)<span /></span></div>
                              <div className="form-input">
                                <input type="text" name="lastname" value={formValues.lastname} onChange={handleChange} id="lastname" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Father/Husband Name <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.fatherhusbandname === 'red' ? 'redvalidation_input':''} ${color.fatherhusbandname === 'green' ? 'greenvalidation_input':''}`} >
                                <input type="text"  onChange={handleChange} name="fatherhusbandname" value={formValues.fatherhusbandname} id="fatherhusbandname" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Gender <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.gender === 'red' ? 'redvalidation_input':''} ${color.gender === 'green' ? 'greenvalidation_input':''}`}>
                                <select className={`form-select`}  onChange={handleChange} name="gender" value={formValues.gender} id="gender">
                                <option value=''>Select Gender</option>
                                  <option value='1'>Male</option>
                                  <option value='2'>Female</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">E-Mail <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.email === 'red' ? 'redvalidation_input':''} ${color.email === 'green' ? 'greenvalidation_input':''}`} >
                                <input type="text" className={`form-control`} name="email" onChange={handleChange} value={CandidateData?.personal_email} id="email" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Alternate E-Mail</div>
                              <div className="form-input">
                                <input type="text" className="form-control" name="alternateemail" onChange={handleChange} value={formValues.alternateemail} id="alternateemail"  />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Phone Number <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.phonenumber === 'red' ? 'redvalidation_input':''} ${color.phonenumber === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text" className="form-control" name="phonenumber"  onChange={handleChange} value={formValues.phonenumber?formValues.phonenumber:''} id="phonenumber" placeholder />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Date Of Birth <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.dateofbirth === 'red' ? 'redvalidation_input':''} ${color.dateofbirth === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="date" className="form-control" name="dateofbirth" onChange={handleChange} value={moment(formValues.dateofbirth).format('yyyy-MM-DD')} id="dateofbirth"  />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Age</div>
                              <div className="form-input">
                                <input type="text" className="form-control" disabled name="age" onChange={handleChange} value={formValues.age} id="age"  />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Hobbies</div>
                              <div className="form-input">
                                <input type="text" className="form-control" name="hobbies" onChange={handleChange} value={formValues.hobbies} id="hobbies"  />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Marital Status <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.Marital_status === 'red' ? 'redvalidation_input':''} ${color.Marital_status === 'green' ? 'greenvalidation_input':''}`}>
                                <select className="form-select" name="marital_status" onChange={handleChange} value={formValues.marital_status} id="marital_status">
                                <option value="">--Marital Status--</option>
                                  <option value="1">Married</option>
                                  <option value="2">Unmarried</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Wedding Anniversary Date</div>
                              <div className="form-input">
                                <input type="date" name="weddinganniversary" onChange={handleChange} value={formValues.weddinganniversary} id="weddinganniversary" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Date of joining</div>
                              <div className="form-input">
                                <input type="date" name="dateofjoining" onChange={handleChange} value={moment(CandidateData?.joining_date).format('yyyy-MM-DD')} id="dateofjoining" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Blood Group <sup className="error_mgs">*</sup></div>
                              <div className="form-input">
                                <input type="text"  id="bloodgroup" name="bloodgroup" onChange={handleChange} value={formValues.bloodgroup} className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Weight <sup>( Kg )</sup> </div>
                              <div className="form-input">
                                <input type="text"  id="Weight" name="Weight" onChange={handleChange} value={formValues.Weight} className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Height <sup>( inches )</sup></div>
                              <div className="form-input">
                                <input type="text"  id="Height" onChange={handleChange} value={formValues.Height} name="Height" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Emergency Contact Person <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.emergencycontactperson === 'red' ? 'redvalidation_input':''} ${color.emergencycontactperson === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text"  onChange={handleNumericChange} id="emergencycontactperson" value={Numeric.emergencycontactperson} name="emergencycontactperson" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Emergency Contact person Relationship <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.personrelation === 'red' ? 'redvalidation_input':''} ${color.personrelation === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text"  onChange={handleChange} id="personrelation" name="personrelation" value={formValues.personrelation} className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Emergency Phone Number <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.emergencyphonenumber === 'red' ? 'redvalidation_input':''} ${color.emergencyphonenumber === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text"  onChange={handleNumericChange} id="emergencyphonenumber" name="emergencyphonenumber" value={Numeric.emergencyphonenumber} className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Nationality <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.nationality === 'red' ? 'redvalidation_input':''} ${color.nationality === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text" onChange={handleChange} name="nationality" value={formValues.nationality} id="nationality" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Aadhaar Card Number <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.aadhaarcardnumber === 'red' ? 'redvalidation_input':''} ${color.aadhaarcardnumber === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text" onChange={handleChange} name="aadhaarcardnumber" value={formValues.aadhaarcardnumber} id="aadhaarcardnumber" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Upload Aadhar Card <sup className="error_mgs">*</sup></div>
                              <div className={`form-input input-group  ${color.aadharcardfile === 'red' ? 'redvalidation_input':''} ${color.aadharcardfile === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="file" onChange={handleAadharcardFilesChange} name="aadharcardfile"  className="form-control uploadbtn" id="aadharcardfile" />
                                {AadharcardFiles != ''?<button class="btn_2 btn-2"><i class="icon icon-cross"></i></button>:''}

                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Pan Card Number <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.pancardnumber === 'red' ? 'redvalidation_input':''} ${color.pancardnumber === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text" onChange={handleChange} name="pancardnumber" value={formValues.pancardnumber} id="pancardnumber" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Upload Pan Card <sup className="error_mgs">*</sup></div>
                              <div className={`form-input input-group ${color.filepancard === 'red' ? 'redvalidation_input':''} ${color.filepancard === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="file" onChange={handleFilepancardChange} name="filepancard"  className="form-control uploadbtn" id="filepancard" />
                                {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">UAN Number</div>
                              <div className="form-input">
                                <input type="text" name="uanno"  onChange={handleChange} value={formValues.uanno} id="uanno"  className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Passport Number</div>
                              <div className="form-input">
                                <input type="text" name="Passportno"  onChange={handleChange} id="Passportno" value={formValues.Passportno} className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Passport size Photograph <sup className="error_mgs">*</sup></div>
                              <div className={`form-input input-group ${color.passportSizePhoto === 'red' ? 'redvalidation_input':''} ${color.passportSizePhoto === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="file" name="passportSizePhoto"  onChange={handlePassportSizePhotoChange} className="form-control uploadbtn" id="passportSizePhoto" />
                                {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Fully Vaccination Certificates</div>
                              <div className="form-input input-group">
                                <input type="file" name="Vaccination" onChange={handleVaccinationChange}  className="form-control uploadbtn" id="Vaccination" />
                                {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Upload Address Proof <sup className="error_mgs">*</sup></div>
                              <div className={`form-input input-group ${color.AddressProof === 'red' ? 'redvalidation_input':''} ${color.AddressProof === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="file" name="AddressProof" onChange={handleAddressProofChange}  className="form-control uploadbtn" id="AddressProof" />
                                {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab_sub_ttl mb00">Address</div>
                        <div className="row mb25">
                          <div className="col-md-6">
                            <div className="form-blk mb10">
                              <div className="form-label">Current Address <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.currentAddress === 'red' ? 'redvalidation_input':''} ${color.currentAddress === 'green' ? 'greenvalidation_input':''}`}>
                                <textarea  className="form-control form-control1" onChange={handleChange} name="currentAddress" id="currentAddress" value={formValues.currentAddress} />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-blk mb10">
                              <div className="form-label">Permanent Address <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.PermanentAddress === 'red' ? 'redvalidation_input':''} ${color.PermanentAddress === 'green' ? 'greenvalidation_input':''}`}>
                                <textarea  className="form-control form-control1" onChange={handleChange} name="PermanentAddress"  id="PermanentAddress" value={formValues.PermanentAddress} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab_sub_ttl">Bank Details</div>
                        <div className="row mb25">
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Salary Bank <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.bankSalaryType === 'red' ? 'redvalidation_input':''} ${color.bankSalaryType === 'green' ? 'greenvalidation_input':''}`}>
                                <select className="form-select" name="bankSalaryType" onChange={handleChange} id="bankSalaryType">
                                  <option value="">Select Salary Type</option>
                                  <option value={1}>Salary Account</option>
                                  <option value={2}>Saving Account</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Salary Account Number <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.accountno === 'red' ? 'redvalidation_input':''} ${color.accountno === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text" name="accountno" id="accountno" onChange={handleChange} placeholder="Enter Salary Account Number" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk mb10">
                              <div className="form-label">Salary IFSC Code <sup className="error_mgs">*</sup></div>
                              <div className={`form-input ${color.ifsc_code === 'red' ? 'redvalidation_input':''} ${color.ifsc_code === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="text" name="ifsc_code" id="ifsc_code" onChange={handleChange} placeholder="Enter Salary IFSC Code" className="form-control form-control1" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-blk">
                              <div className="form-label">Upload Cancel Check <sup className="error_mgs">*</sup></div>
                              <div className={`form-input input-group ${color.cancelCheck === 'red' ? 'redvalidation_input':''} ${color.cancelCheck === 'green' ? 'greenvalidation_input':''}`}>
                                <input type="file" name="cancelCheck" onChange={handleCancelCheckChange} className="form-control uploadbtn" id="cancelCheck" />
                                {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab_footer text-end">
                        <button className="btn_5" type="submit">Save & Next</button>
                      </div>
                      </form>
                    </div>
                    <AddFamilyDetail emailCheck={emailCheck} userID={CandidateData?.condidateID} saveFamilyDetails={saveFamilyDetails} tab={tab} setTab={setTab}/>
                    
                  </div>
                </div>
              </div>
              <div className="col-md-1" />
            </div>
          </div>
          <div className="dash_footer">
            @2023 Hive. All rights reserved.
          </div>
        </main>
        
        
        
        </>}
        </>
        }
         

        </>
    )
}
export default NewJoiningFrom;